import { onCleanup } from 'solid-js';
export default function clickOutside(element, accessor) {
    const onClick = (e) => !element.contains(e.target) && accessor()(e);
    document.body.addEventListener('click', onClick);
    onCleanup(() => document.body.removeEventListener('click', onClick));
}
